import * as React from 'react';

interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical';
}

export const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
  ({ orientation = 'horizontal', className, ...props }, ref) => {
    const base = orientation === 'vertical' ? 'w-px h-full' : 'h-px w-full';
    return <div ref={ref} className={`${base} bg-border ${className || ''}`} {...props} />;
  }
);

Separator.displayName = 'Separator';

export default Separator;